import React, { Component } from 'react'

export default class About extends Component {
  render() {
    return (
      <div>
        <section className="colorlib-about" data-section="about">
        <div className="colorlib-narrow-content">
            <div className="row">
            <div className="col-md-12">
                <div className="row row-bottom-padded-sm animate-box" data-animate-effect="fadeInLeft">
                <div className="col-md-12">
                    <div className="about-desc">
                    <span className="heading-meta">About Me</span>
                    <h2 className="colorlib-heading">Who Am I?</h2>
                    <p>I am a graduate student at NYU majoring in Computer Science and specializing in Deep Learning. 
                        I am a tinker and technologist at heart and I love learning new technologies through weekend projects like this 
                        website I put together to learn React.js.  
                    </p>
                    <p>When I am not busy geeking around, I dance. I am a trained dancer in the beautiful Indian classical dance form Kathak.</p>
                    </div>
                </div>
                </div>
            </div>
            </div>
        </div>
        </section>
        <section className="colorlib-about">
        <div className="colorlib-narrow-content">
            <div className="row">
            <div className="col-md-6 col-md-offset-3 col-md-pull-3 animate-box" data-animate-effect="fadeInLeft">
                <span className="heading-meta">What I do?</span>
                <h2 className="colorlib-heading">Here are some of my expertise</h2>
            </div>
            </div>
            <div className="row row-pt-md">
            <div className="col-md-4 text-center animate-box">
                <div className="services color-1">
                <span className="icon">
                    <i className="icon-bulb" />
                </span>
                <div className="desc">
                    <h3>Machine Learning & Deep Learning with Python</h3>
                    <p>I have experience building machine learning solutions in the industry as well 
                        as through projects in academia. Although there are several amazing languages out there
                        I prefer Python for machine learning and deep learning. Having spent six years
                        coding in Python I enjoy it the most.  
                    </p>
                </div>
                </div>
            </div>
            <div className="col-md-4 text-center animate-box">
                <div className="services color-3">
                <span className="icon">
                    <i className="icon-data" />
                </span>
                <div className="desc">
                    <h3>Databases and Big Data</h3>
                    <p>As a computer science major in undergrad I have been exposed to databases from long
                        and to add to that I have worked with one of the most complex, large and high risk 
                        information containing databases at HSBC. These experiences combined have made me extremely
                        skilled at relational and non relational databases like MySQL, PL/SQL and MongoDB. 
                        My experience at NYU has also exposed me to big data frameworks like Hadoop and Spark.  
                    </p>
                </div>
                </div>
            </div>
            <div className="col-md-4 text-center animate-box">
                <div className="services color-5">
                <span className="icon">
                    <i className="icon-cloud-storage" />
                </span>
                <div className="desc">
                    <h3>Cloud Computing with AWS</h3>
                    <p>At my previous workplace, I have worked on internal cloud platform to facilitate a data lake project
                        and at NYU I gained a lot of experience working with Amazon Web Services by building several intricate
                        projects. 
                    </p>
                </div>
                </div>
            </div>
            {/*
            <div className="col-md-4 text-center animate-box">
                <div className="services color-2">
                <span className="icon">
                    <i className="icon-data" />
                </span>
                <div className="desc">
                    <h3>Dev Ops</h3>
                    <p>Jenkins , Kubernetes , Docker </p>
                </div>
                </div>
            </div>
            <div className="col-md-4 text-center animate-box">
                <div className="services color-4">
                <span className="icon">
                    <i className="icon-layers2" />
                </span>
                <div className="desc">
                    <h3>Graphic Design</h3>
                    <p>My friend knows .. P</p>
                </div>
                </div>
            </div>
            <div className="col-md-4 text-center animate-box">
                <div className="services color-6">
                <span className="icon">
                    <i className="icon-phone3" />
                </span>
                <div className="desc">
                    <h3>Digital Marketing</h3>
                    <p>I use Instagram eight hours a day :) </p>
                </div>
                </div>
            </div>
            */}
            </div>
        </div>
        </section>
      </div>
    )
  }
}